// src/components/About.js
import React from 'react';
import './About.css';

function About() {
  return (
    <section id="about" className="about">
      <h2>About Us</h2>
      <p>We are a state-of-the-art fitness center dedicated to helping you achieve your goals.</p>
    </section>
  );
}

export default About;
